import {useContext, useEffect, useState} from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";

import styles from "./styles/NavigationPrimary.module.scss";
import classNames from "classnames";
import {primaryNavHeight} from "../../utils/Settings";
import {StoreContext} from "../../stores/StoreLoader";
import SchoolBlocksHeader from "./SchoolBlocksHeader";
import * as React from "react";
import {useMainUrl} from "../../hooks/useMainUrl";

const NavigationPrimary = observer(props => {
    const {interfaceStore} = useContext(StoreContext);
    const [visible, setVisible] = useState(!props.heroIsEnabled && !props.isWelcomePage);

    const mainUrl = useMainUrl();

    useEffect(() => {
        // this is running in a useEffect because scrollPosition is always 0 on SSR so otherwise a reload while scrolled
        // down doesn't hydrate with the correct classNames and it doesn't update
        if (interfaceStore.scrollPosition > primaryNavHeight || !props.heroIsEnabled) {
            setVisible(true);
        } else if (visible) {
            setVisible(false);
        }
    }, [interfaceStore.scrollPosition])

    const containerClassName = classNames({
        [styles.schoolBlocksHeader]: true,
        [styles.schoolBlocksHeaderHeroIsEnabled]: props.heroIsEnabled,
        [styles.schoolBlocksHeaderVisible]: visible,
    });

    return (
        <div className={containerClassName}>
            <SchoolBlocksHeader mainUrl={mainUrl} hideNavigation={true} hideLoginButton={false} preventTabbing={props.isWelcomePage || !visible}/>
        </div>
    );
});

NavigationPrimary.propTypes = {
    isWelcomePage: PropTypes.bool,
    heroIsEnabled: PropTypes.bool,
};

export default NavigationPrimary;
